// Libraries
import React from 'react';
import {css} from 'aphrodite/no-important';
// Core
import {randomElementFromArray} from '../core/Utilities';
import CoreMetrics, {createExpandableMediaQueryStylesheet} from '../core/Metrics';
import ContentData from '../core/ContentData';
import CoreStyles from '../core/Styles';
import {TitleText, TaglineText, HeadingMediumText, LabelMediumText, LabelSmallText} from '../core/Type';
import {FixedSpace, FlexibleSpace} from '../core/Spacing';
// Icons
import ContentIcon from '../icons/ContentIcon';
// Controls
import TabBar from '../controls/TabBar';
// Layouts
import {OneColumnLayout} from '../layouts/Grid';
import ToolBar from '../layouts/ToolBar';
// Modules
import SiteBar from '../modules/SiteBar';

export default class ClassHomePage extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            page: {
                display: "flex",
                flexDirection: "column-reverse",
            },
            toolbarContent: {
                display: "flex",
                flexDirection: "row",
                width: CoreMetrics.Grid.FixedWidth,
                height: "100%",
                marginLeft: "auto",
                marginRight: "auto",
            },
            toolbar: {
                paddingLeft: 0,
                paddingRight: 0,
            },
            table: {
                width: "100%",
                tableLayout: "fixed",
                textAlign: "left",
            },
            tableHeader: {
                height: CoreMetrics.ElementHeight.Medium(),
            },
            firstColumn: {
                width: "33%",
            },
        });

        const className = "1st period: " + randomElementFromArray(ContentData.Subjects);

        return (
            <div className={css(styles.page)}>
                <OneColumnLayout column1={(
                    <div>
                        <ToolBar styles={[styles.toolbar, CoreStyles.hairlineStrokeBottom]}>
                            <HeadingMediumText>Assignments for {className}</HeadingMediumText>
                            <FlexibleSpace />
                            <TabBar items={["Active", "Past", "Drafts"]} selectedIndex={0} />
                        </ToolBar>
                        <table className={css(styles.table)}>
                            <thead>
                                <tr className={css([styles.tableHeader, CoreStyles.hairlineStrokeBottom])}>
                                    <th className={css(styles.firstColumn)}>
                                        <LabelMediumText>Assignment name</LabelMediumText>
                                    </th>
                                    <th>
                                        <LabelMediumText>Due date &amp; time</LabelMediumText>
                                    </th>
                                    <th>
                                        <LabelMediumText>Assigned on</LabelMediumText>
                                    </th>
                                    <th>
                                        <LabelMediumText>Completion</LabelMediumText>
                                    </th>
                                    <th>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...Array(25).keys()].map((item, i) => {
                                    return <AssignmentRow key={i} />;
                                })}
                            </tbody>
                        </table>
                    </div>
                )} />
                <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XLarge} />
                <ToolBar>
                    <div className={css(styles.toolbarContent)}>
                        <TabBar items={["Assignments", "Progress", "Activity", "Roster", "Settings"]} selectedIndex={0} />
                    </div>
                </ToolBar>
                <ClassHeader title={className} />
                <SiteBar />
            </div>
        );
    }
}

class ClassHeader extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            container: {
                width: "100%",
                paddingTop: CoreMetrics.ElementSpacing.XLarge(),
                paddingBottom: CoreMetrics.ElementSpacing.XLarge(),
                display: "flex",
                flexDirection: "column",
                alignContent: "flex-start",
                justifyContent: "center",
                backgroundColor: CoreMetrics.Color.Neutral.OffWhite,
            },
            row: {
                display: "flex",
                flexDirection: "row",
                alignContent: "flex-start",
                justifyContent: "stretch",
            },
        });
        return (
            <div className={css(styles.container)}>
                <OneColumnLayout column1={(
                    <div className={css(styles.row)}>
                        <div className={css(styles.heading)}>
                            <LabelSmallText>Back to all classes</LabelSmallText>
                            <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XSmall} />
                            <TitleText>{this.props.title}</TitleText>
                        </div>
                        <FlexibleSpace />
                        <div>
                            <LabelSmallText>Class code</LabelSmallText>
                            <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XSmall} />
                            <TaglineText>34A15P</TaglineText>
                        </div>
                    </div>
                )} />
            </div>
        );
    }
}

class AssignmentRow extends React.Component {
    render() {
        const styles = createExpandableMediaQueryStylesheet({
            row: {
                height: CoreMetrics.ElementHeight.Medium(),
            },
            cell: {
                paddingBottom: CoreMetrics.ElementPadding.XSmall(),
                paddingTop: CoreMetrics.ElementPadding.XSmall(),
                ":first-child": {
                    width: "33%",
                },
                ":last-child": {
                    textAlign: "right",
                },
            },
            titleContainer: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
            },
            textContainer: {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                paddingTop: CoreMetrics.ElementPadding.Medium(),
                paddingBottom: CoreMetrics.ElementPadding.Medium(),
            },
        });
        return (
            <tr className={css([styles.row, CoreStyles.hairlineStrokeBottom])}>
                <td className={css(styles.cell)}>
                    <div className={css(styles.titleContainer)}>
                        <ContentIcon />
                        <FixedSpace size={FixedSpace.Size.Medium} />
                        <div className={css(styles.textContainer)}>
                            <LabelMediumText>{randomElementFromArray(ContentData.Content)}</LabelMediumText>
                            <FixedSpace variant={FixedSpace.Variant.Vertical} size={FixedSpace.Size.XXSmall} />
                            <LabelSmallText>{randomElementFromArray(ContentData.Units)}</LabelSmallText>
                        </div>
                    </div>
                </td>
                <td className={css(styles.cell)}><LabelSmallText>Today, 11:59 PM</LabelSmallText></td>
                <td className={css(styles.cell)}><LabelSmallText>Nov 29</LabelSmallText></td>
                <td className={css(styles.cell)}><LabelSmallText>17 / 20</LabelSmallText></td>
                <td className={css(styles.cell)}><LabelMediumText>View report</LabelMediumText></td>
                <td className={css(styles.cell)}><LabelMediumText>Actions</LabelMediumText></td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/demo/ClassHomePage.jsx